module.exports = __webpack_public_path__ + "img/icon_bell_active.8272c2ed.svg";